import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetJobOffer, GetJobOfferFilter } from '../models/job-offer/get-job-offer';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Paged } from '../models/shared/paged';
import { HttpUtil } from '../utils/http-util';
import { AddJobOffer, AddJobOfferResponse } from '../models/job-offer/add-job-offer';
import { GetJobOfferCandidate } from '../models/job-offer/get-job-offer-candidate';

@Injectable({
  providedIn: 'root'
})
export class JobOfferService {

  constructor(
    private _http: HttpClient
  ) { }

  public getList(filter: GetJobOfferFilter): Observable<Paged<GetJobOffer>> {
    return this._http.get<Paged<GetJobOffer>>(`${environment.api.url}/JobOffer`, {
      params: HttpUtil.toHttpParams(filter)
    });
  }

  public getById(jobOfferId: number): Observable<GetJobOffer | undefined> {
    return this._http.get<GetJobOffer | undefined>(`${environment.api.url}/JobOffer/${jobOfferId}`);
  }

  public UpsertJobOffer(model: AddJobOffer): Observable<AddJobOfferResponse> {
    return this._http.post<AddJobOfferResponse>(`${environment.api.url}/JobOffer`, model);
  }

  public deleteJobOffer(jobOfferId: number): Observable<null> {
    return this._http.delete<null>(`${environment.api.url}/JobOffer/${jobOfferId}`);
  }

  public getJobOffersCandidate(params: {
    page: number,
    pageSize: number,
    appliedOffers: boolean,
    stateId?: number,
    departmentId?: number,
    positionId?: number,
    search?: string
  }){
    return this._http.get<Paged<GetJobOfferCandidate>>(`${environment.api.url}/JobOffer/candidate`, {
      params: HttpUtil.toHttpParams(params)
    });
  }

  public getJobOffersCandidateById(id: number){
    return this._http.get<GetJobOfferCandidate>(`${environment.api.url}/JobOffer/candidate/${id}`);
  }
}